import { render, staticRenderFns } from "./ActivityPageCard.vue?vue&type=template&id=31638da0&scoped=true&"
import script from "./ActivityPageCard.vue?vue&type=script&lang=js&"
export * from "./ActivityPageCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPageCard.vue?vue&type=style&index=0&id=31638da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31638da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
